export default __webpack_public_path__ + "static/dhiraj-efdc7c2c2ec4ac57370dddb61a41cfa1.png";